import styled from "styled-components";
import { breakpointTheme } from "Custom/StylesAppSpecific/AppStyling";

import { AutoGrid } from "Core/Components/AutoGrid";

export const UserPageDescriptionGrid: any = styled(AutoGrid)`
    font-family: "Nexa Light";
    padding: 60px 15px;
    width: 100%;
    max-width: 1140px;
    margin: 0 auto;
`;
